// src/pages/geral/Login.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToken } from '../../contexts/geral/TokenContext';
import { useUser } from '../../contexts/geral/UserContext';
import UsuarioPerfilEnum from '../../models/geral/UsuarioPerfilEnum';
import { FaSignInAlt } from 'react-icons/fa';
import { cleanupOldWhatsappAvatars } from '../../utils/whatsappAvatarStorage';
import { autenticarNoErp } from '../../services/geral/LoginService';
import { saveAuthTokens } from '../../utils/AuthStorage';
import './Login.css';

const Login = () => {
    const [login, setLogin] = useState('');
    const [senha, setSenha] = useState('');
    const [message, setMessage] = useState('');
    const { setToken, setTokenExpires } = useToken();
    const { setUser } = useUser();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);


    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const response = await autenticarNoErp(login, senha);

            setToken(response.data.token.accessToken);
            setTokenExpires(new Date(response.data.token.expiresIn));
            setUser(response.data.user);
            cleanupOldWhatsappAvatars();

            saveAuthTokens(response.data.token);
            localStorage.setItem('usuarioId', response.data.user.id);
            localStorage.setItem('usuarioNome', response.data.user.nome);
            localStorage.setItem('userLogin2', JSON.stringify(response.data.user));
            
            switch (response.data.user.perfil) {
                case UsuarioPerfilEnum.Admin:
                    navigate('/');
                    break;
                case UsuarioPerfilEnum.Caixa:
                    navigate('/pdv');
                    break;
                case UsuarioPerfilEnum.Pedidos:
                    navigate('/pedido');
                    break;
                case UsuarioPerfilEnum.Garcom:
                    navigate('/mesaPage');
                    break;
                default:
                    navigate('/');
            }

        } catch (error) {
            setMessage(error?.response?.data?.message || 'Usuário ou senha inválidos!');
            setLoading(false);        
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">

            {loading && (
                <div className="login-loading">
                    <div
                        className="spinner-border"
                        role="status"
                        style={{ width: '3rem', height: '3rem', color: '#3d6df2' }}
                    />
                    <strong className="login-loading-text">
                        Carregando...
                    </strong>
                </div>
            )}

            {!loading && (
                <div className="login-wrapper">

                    <div className="login-card">

                        {/* LOGO */}
                        <div className="login-logo">
                            <img
                                src="/images/logo-infomaio.png"
                                alt="Infomaio"
                            />
                        </div>

                        <form onSubmit={onSubmit}>

                            <div className="mb-3">
                                <input
                                    type="text"
                                    className="form-control login-input"
                                    placeholder="Login"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <input
                                    type="password"
                                    className="form-control login-input"
                                    placeholder="Senha"
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="btn w-100 login-btn"
                                disabled={loading}
                            >
                                <FaSignInAlt className="login-icon" />
                                Acessar
                            </button>

                        </form>

                        {message && (
                            <p className="login-error">
                                {message}
                            </p>
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
